import { render, staticRenderFns } from "./drawer_allergyList.vue?vue&type=template&id=7366b745&scoped=true&"
import script from "./drawer_allergyList.vue?vue&type=script&lang=js&"
export * from "./drawer_allergyList.vue?vue&type=script&lang=js&"
import style0 from "./drawer_allergyList.vue?vue&type=style&index=0&id=7366b745&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7366b745",
  null
  
)

export default component.exports